import React from "react";
function QuotationMaster () {
    return (

        <h2>Quotation Master</h2>
    )
    
}
export default QuotationMaster;